/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-51
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_53 from /* 53 */"./53"
import * as /* [auto-meaningful-name] */Module_131 from /* 131 */"./131"
var Af = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, [
    {
      type: "VisibleSwitch"
    }, {
      type: "DisabledSwitch"
    }
  ], {
    type: "SwitchBackground"
  }, {
    type: "WidgetOpacity"
  }, {
    type: "Size",
    sizeRange: [[Module_131.j, Module_53.o], [Module_131.i, Module_53.m]]
  }, {
    type: "Coordinate"
  }
]
export { Af }
